// src/pages/OrderConfirmation.jsx
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import Receipt from '../components/checkout/Receipt';
import { useCurrency } from '../context/CurrencyContext';
import { useContent } from '../context/ContentContext';      // ← Add this import
import SectionLoader from '../components/common/SectionLoader'; // optional – if you want to show loader

function OrderConfirmation() {
  const { state } = useLocation();
  const transaction = state?.transaction || {};

  const { formatPrice } = useCurrency();
  const { content, loading: contentLoading } = useContent();   // ← Get context data

  // Safety check
  if (!transaction.cart || transaction.cart.length === 0) {
    return (
      <div className="max-w-4xl mx-auto px-4 py-16 text-center">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">Order Not Found</h1>
        <p className="text-lg text-gray-600 mb-8">
          Something went wrong or the page was refreshed.
        </p>
        <Link
          to="/shop"
          className="inline-block bg-primary text-white px-8 py-4 rounded-full hover:bg-primary/90 font-medium"
        >
          Continue Shopping
        </Link>
      </div>
    );
  }

  // Construct logo URL the same way as in Navbar
  const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000';

  const brandLogo = content?.settings?.brand_logo
    ? `${API_BASE}${content.settings.brand_logo.startsWith('/') ? '' : '/'}${content.settings.brand_logo}`
    : null;

  const brandName = content?.settings?.brand_name || 'Your Shop Name';

  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <div className="text-center mb-10">
        <h1 className="text-4xl md:text-5xl font-bold text-green-700 mb-4">
          Order Confirmed!
        </h1>
        <p className="text-xl text-gray-700 mb-4">
          Thank you for your purchase. Your payment was successful.
        </p>
        <div className="inline-block bg-green-50 border border-green-200 rounded-lg px-6 py-4">
          <p className="text-lg font-medium">
            Receipt Number:{' '}
            <span className="font-bold text-primary text-xl">
              {transaction.receiptNumber || '—'}
            </span>
          </p>
          {transaction.transactionRef && (
            <p className="text-sm text-gray-600 mt-2">
              Paystack Ref: {transaction.transactionRef}
            </p>
          )}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-xl p-6 md:p-10">
        <h2 className="text-2xl font-semibold mb-6 text-center md:text-left">
          Your Receipt
        </h2>

        {contentLoading ? (
          <div className="py-12">
            <SectionLoader message="Loading business details..." />
          </div>
        ) : (
          <Receipt
            cart={transaction.cart}
            subtotal={transaction.fees?.subtotal || 0}
            vat={transaction.fees?.vat || 0}
            shipping={transaction.fees?.shipping || 0}
            total={transaction.fees?.total || 0}
            formatPrice={formatPrice}
            // ── Now using real values from context ──
            business={{
              name: brandName,
              logo: brandLogo || '/assets/images/placeholder-logo.png', // fallback
            }}
            shippingAddress={transaction.shippingAddress}
            customer={{
              full_name: transaction.shippingAddress?.name || 'Customer',
              email: transaction.shippingAddress?.email || '',
              phone: transaction.shippingAddress?.phone || '',
            }}
            receiptNumber={transaction.receiptNumber}
            transactionRef={transaction.transactionRef}
          />
        )}
      </div>

      <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
        <Link
          to="/shop"
          className="bg-primary text-white px-8 py-4 rounded-full hover:bg-primary/90 font-medium text-center"
        >
          Continue Shopping
        </Link>
        <Link
          to="/dashboard"
          className="border-2 border-primary text-primary px-8 py-4 rounded-full hover:bg-primary/10 font-medium text-center"
        >
          View My Orders
        </Link>
      </div>
    </div>
  );
}

export default OrderConfirmation;